import { calculateMonthsUntilUpcomingDate } from './CommonLogic';
const subtractDollarValues = (value1: any, value2: any) => {
  if (value1 === '' || value2 === '' || value1 === undefined || value2 === undefined) {
    return '';
  }
  const num1 = parseFloat(value1.replace('$', ''));
  const num2 = parseFloat(value2.replace('$', ''));
  const result = num1 - num2;
  const formattedResult = result === 0 ? '' : '$' + result.toFixed(2);
  return formattedResult;
};

export const refinePackageData = (data: any) => {
  const packageDetailsObj: any = {
    name: '',
    address: '',
    desc: '',
    stay: '',
    dates: '',
    maxGuest: '',
    tourGift: '',
    totalDue: '',
    dueAtBooking: '',
    dueToday: '',
    retailVal: '',
    accommodation: '',
    days: '',
    nights: '',
  };
  if (data) {
    const retailVal = data?.retailValue || '';
    const roomTypeData = data?.roomTypes[0] || {};
    const retailPrice = roomTypeData?.highSeasonRetailPrice || '';
    const updatedRetPrice = retailPrice || retailVal;
    const PropertyData = roomTypeData?.property || {};
    //const pkgCity = roomTypeData?.property?.city || '';
    const pkgCountry = roomTypeData?.property?.country || '';
    const pkgState = roomTypeData?.property?.stateProvince || '';
    const pbeLocation = roomTypeData?.property?.pbeLocation || '';
    const hotelFlag = roomTypeData?.property?.isHotel || '';
    const isHotel = hotelFlag?.toUpperCase() === 'Y' ? true : false;
    const address =
      pkgState && pkgState.trim().toLowerCase() !== pkgCountry.trim().toLowerCase()
        ? `${pkgState}, ${pkgCountry}`
        : pkgCountry;
    const resortAddr = pbeLocation ? pbeLocation : address;
    const pkgAddress = isHotel ? address : resortAddr;
    //const pkgAddress = `${pkgCity}, ${pkgState}`;
    const pkgDays = roomTypeData?.numberOfDays || '';
    const pkgNight = roomTypeData?.numberOfNights || '';
    const pkgStay = `${pkgDays} days / ${pkgNight} nights`;
    const pkgStartingCost = roomTypeData?.startingCost || '';
    const difDates = calculateMonthsUntilUpcomingDate(data?.finalDate);
    const bookDate = difDates || '';
    const pkgDepositAmount = roomTypeData?.depositAmount || '';
    const pkgDueAtAmt = subtractDollarValues(pkgStartingCost, pkgDepositAmount);
    packageDetailsObj.name = PropertyData?.name || '';
    packageDetailsObj.address = pkgAddress || '';
    packageDetailsObj.desc = roomTypeData?.roomTypeDescription || '';
    packageDetailsObj.stay = pkgStay || '';
    packageDetailsObj.dates = bookDate;
    packageDetailsObj.maxGuest = `${roomTypeData?.sleepCapacity} `;
    packageDetailsObj.tourGift = (data?.premiums && data?.premiums[0]) || '';
    packageDetailsObj.totalDue = roomTypeData?.startingCost || '';
    packageDetailsObj.dueAtBooking = `${pkgDueAtAmt}`;
    packageDetailsObj.dueToday = pkgDepositAmount;
    packageDetailsObj.retailVal = updatedRetPrice || '';
    packageDetailsObj.accommodation = roomTypeData?.roomTypeDescription;
    packageDetailsObj.days = pkgDays;
    packageDetailsObj.nights = pkgNight;
  }
  return packageDetailsObj;
};
